import React from 'react';
import { NavLink } from 'react-router-dom';

const Banner = () => {
  const orgName = sessionStorage.getItem('organizationName');
  const role = sessionStorage.getItem(`${orgName}_role`);
  return (
    <div>
      <h1 className='text-2xl font-bold'>Dashboard</h1>
    </div>
    // <div className='flex flex-row justify-center bg-banner-gradient h-[100px] rounded-2xl'>
    //     <div className='flex flex-col justify-center items-center'>
    //         <p className='text-2xl max-sm:text-2xl text-white mt-2 ml-9 font-semibold tracking-wider'>Welcome to CSM</p>
    //         <a href="https://4xportal.com" target="_blank" rel="noopener noreferrer">
    //         <p className='text-md text-white ml-3'>BY 4xportal.com</p></a>
    //         {(role === "admin" || role === "agent") &&(
    //         <NavLink to="/home/LiveChat">
    //             <button className='p-2 m-4 bg-gray-300 rounded-lg hover:bg-blue-700 hover:text-white'>Live Chat</button>
    //         </NavLink>
    //       )}
    //     </div>
    // </div>
  )
}

export default Banner;